import './footer.css';

export const Footer = () => <></>;
